// @todo hook up socket
import React, {useEffect, useState} from 'react';
import Page from './page';
import Button from './Button';
import Loader from './Loader';
import {useDispatch, useSelector} from 'react-redux';
import {navigateNext} from '../../action/actions';
import Api from '../../util/api';
import {publicBuildUrl} from '../../config/config';
import Socket from "../../util/socket";

const text = 'Start je game door het spelnummer in te vullen.';

const WaitingForPlayers = () => {
    const {app: {room: {name}}} = useSelector((state) => state);
    const dispatch = useDispatch();
    const [loaded, setLoaded] = useState(0);

    useEffect(() => {
        createSocket();
    }, []);

    const createSocket = () => {
        let socket = new Socket();

        socket.subscribe('info', ({participants, expectedParticipants}) => {
            setLoaded((participants - 1) / expectedParticipants * 100);
        });

        socket.connect().then(
            () => socket.join(name)
        );
    }

    return (
        <Page title={'Waiting for players'}>
            <div className={'bodyContainer'} style={{justifyContent: 'center'}}>
                <div style={styles.container}>
                    <div style={styles.loader}>
                        <img src={`${publicBuildUrl}icons/IconParticipantsGreen.png`} alt={''}
                             style={{height: '44px', marginRight: '25px'}}/>
                        <Loader color={'green'} loaded={loaded}/>
                    </div>
                    <div style={styles.text}>{text}</div>
                    <div style={styles.inputContainer}>
                        <div style={styles.inputLabel}>
                            Spelcode:
                        </div>
                        <div style={styles.inputCode}>
                            {name}
                        </div>
                    </div>
                    <div style={{width: '230px'}}>
                        <Button onClick={() => {
                            Api.navigateDeviceNext().then(
                                () => {
                                    dispatch(navigateNext());
                                })
                            }} color={'pink'} text={'Start het spel'}/>
                    </div>
                </div>
            </div>
        </Page>
    );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '960px',
    },
    inputContainer: {
        backgroundColor: 'white',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90px',
        marginBottom: '50px',
        width: '960px',
    },
    inputLabel: {
        color: '#e41b60',
        fontFamily: 'Ubuntu',
        fontSize: '48px',
        marginRight: '15px',
    },
    inputCode: {
        color: '#e41b60',
        fontFamily: 'Ubuntu',
        fontSize: '48px',
        fontWeight: 500,
    },
    loader: {
        display: 'flex',
        marginBottom: '50px',
        width: '100%',
    },
    text: {
        color: '#003d4c',
        fontFamily: 'Ubuntu',
        fontSize: '27px',
        marginBottom: '50px',
    }
}

export default WaitingForPlayers;
